export default {
  data() {
    return {
      values: {},
    };
  },

  props: {
    redirectUrl: {
      type: String,
      required: false,
      default: '',
    },
    shouldShowErrorInToast: {
      type: Boolean,
      default: true,
    },
    shouldDisplaySubmitButton: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formAction() {
      return window.route('api.customer.login');
    },
  },

  methods: {
    getRetrievePasswordUrl() {
      let url = '';
      try {
        url = window.route('retrieve_password_page');
      } catch (error) {}
      return url;
    },

    async addTrackingInformation() {
      let email = '';
      if (this.fields?.email?.value) {
        email = this.fields.email.value;
      } else if (this.fields?.emailOrPhone?.value) {
        email = this.fields.emailOrPhone.value;
      }
      const event = await window.tracking.getLoginFormTracking(email);
      window.tracking.pushEvent(event);
    },
  },
};
